// eslint-disable-next-line import/prefer-default-export
export const WardType = {
  GENERAL: "general",
  EMERGENCY: "emergency",
  MEDICAL: "medical",
  SURGICAL: "surgical",
  MATERNITY: "maternity",
  INTENSIVE_CARE_UNIT: "intensive_care_unit"
} as const;
